module.exports = __webpack_public_path__ + "static/media/co02.9330b64d.png";